import { idOf } from 'shared-js/object-differ'

export function applyForEntityTypes (obj, types, func) {
  for (let type of types) {
    applyForEntityType(obj, type, func)
  }
}

export function applyForEntityType (obj, type, func) {
  if (obj === null || typeof obj !== 'object') {
    return
  }

  let unvisited = [obj]

  while (unvisited.length > 0) {
    let cur = unvisited.pop()

    if (cur.hasOwnProperty('entityType') && cur.entityType === type) {
      func(cur)
    }

    Object.keys(cur).forEach(fieldName => {
      let value = cur[fieldName]
      if (Array.isArray(value)) {
        value.forEach(elem => {
          if (elem !== null && typeof elem === 'object') {
            unvisited.push(elem)
          }
        })
      } else if (value !== null && typeof value === 'object') {
        unvisited.push(value)
      }
    })
  }
}

export function findEntityType (obj, type, id) {
  let found = null
  applyForEntityType(obj, type, it => {
    if (idOf(it) === id) {
      found = it
    }
  })

  return found
}
